export default "__VITE_ASSET__4e684653__"